import { render, staticRenderFns } from "./suppliers-edit.vue?vue&type=template&id=08e3e9a2&scoped=true"
import script from "./suppliers-edit.vue?vue&type=script&lang=js"
export * from "./suppliers-edit.vue?vue&type=script&lang=js"
import style0 from "./suppliers-edit.vue?vue&type=style&index=0&id=08e3e9a2&prod&lang=css"
import style1 from "./suppliers-edit.vue?vue&type=style&index=1&id=08e3e9a2&prod&scoped=true&lang=css"
import style3 from "./suppliers-edit.vue?vue&type=style&index=3&id=08e3e9a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e3e9a2",
  null
  
)

export default component.exports